import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { workbenchTodosDataProvider } from './dataProvider';

export function initSocialTradingWorkbenchTodosDataProvider() {
  registerModuleDataProvider(Resources.socialTradingWorkbenchTodos, workbenchTodosDataProvider);
}

initSocialTradingWorkbenchTodosDataProvider();
